import { BarChart3, Search, Settings, UploadCloud } from "lucide-react";
import packageJson from "../../package.json";
import { BrandBadge } from "./BrandBadge";

type TopBarProps = {
  activeView: "search" | "logs";
  onSearchOpen: () => void;
  onLogsOpen: () => void;
};

export function TopBar({ activeView, onSearchOpen, onLogsOpen }: TopBarProps) {
  const isEmbedded =
    typeof window !== "undefined" && window.self !== window.top;

  if (isEmbedded) {
    return null;
  }

  return (
    <header className="top-bar">
      <div className="top-bar__brand">
        <BrandBadge />
        <div>
          <p className="top-bar__eyebrow">MFMA Assistant</p>
          <div className="top-bar__title-row">
            <h1>MFMA Document Search Agent</h1>
            <span className="top-bar__version">v{packageJson.version}</span>
          </div>
        </div>
      </div>
      <nav className="top-bar__actions" aria-label="Workspace actions">
        <button
          className={[
            "icon-button",
            activeView === "search" ? "icon-button--active" : "icon-button--quiet",
          ]
            .filter(Boolean)
            .join(" ")}
          type="button"
          onClick={onSearchOpen}
        >
          <Search size={18} aria-hidden="true" />
          <span>Search</span>
        </button>
        <button
          className={[
            "icon-button",
            activeView === "logs" ? "icon-button--active" : "icon-button--quiet",
          ]
            .filter(Boolean)
            .join(" ")}
          type="button"
          onClick={onLogsOpen}
        >
          <BarChart3 size={18} aria-hidden="true" />
          <span>Logs</span>
        </button>
        <button className="icon-button" type="button">
          <UploadCloud size={18} aria-hidden="true" />
          <span>Upload</span>
        </button>
        <button className="icon-button icon-button--quiet" type="button">
          <Settings size={18} aria-hidden="true" />
          <span>Settings</span>
        </button>
      </nav>
    </header>
  );
}
